<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="12.938"
      viewBox="0 0 14.376 12.938"
      class="scaling-svg"
    >
      <path
        data-name="Icon/Icon/Cloud-upload"
        d="M7.188,12.938a.72.72,0,0,1-.719-.719V8.163l-.938.905a.719.719,0,0,1-1-1.034L6.689,5.952a.721.721,0,0,1,.5-.2.71.71,0,0,1,.507.21L9.852,8.117A.719.719,0,1,1,8.836,9.134l-.93-.93v4.015A.719.719,0,0,1,7.188,12.938Zm5.75-3.847a.719.719,0,0,1-.538-1.2,2.157,2.157,0,0,0-1.618-3.582H10.71a.721.721,0,0,1-.7-.577,2.875,2.875,0,0,0-5.634,0,.721.721,0,0,1-.706.577H3.594A2.156,2.156,0,0,0,1.976,7.895.719.719,0,1,1,.9,8.848a3.595,3.595,0,0,1,2.209-5.94,4.315,4.315,0,0,1,8.159,0,3.6,3.6,0,0,1,2.21,5.94A.722.722,0,0,1,12.938,9.091Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CloudUploadIcon extends Vue {}
</script>

<style>
</style>
